import * as url from './url_helper';

// get Saved Searches List
export const getSavedSearches = async (payload: any) => {
  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }

  const query = `query{
    findByGroupName(Filters: {
       clientId: ${user.id}, 
       groupName: "${payload.groupName}"
       }
      ) 
    {
      clientId   
      name    
      groupName
      createdOn
      dataFields
      id
    }
  }`;

  // return get(url.GET_FILTER_LIST)
  // const res = post(url.GET_FILTER_LIST, data)
  // return res

  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());
  return response.data.findByGroupName;
};

// get Orders
// export const getFilterData = () => get(url.GET_FILTER_DATA)
// export Interface FilterData

export function getNames(list: []) {
  const listNames = list.map((obj: any) => {
    return `{name: "${obj.label}"}`;
  });
  return listNames.join();
}

export const getFilterData = async (data: any) => {
  const { from, to, status, whLocation, comodityType, seller, brand, buyer } =
    data;

  const whLocationNames = getNames(whLocation);
  const comodityTypeNames = getNames(comodityType);
  const sellerNames = getNames(seller);
  const brandNames = getNames(brand);
  const buyerNames = getNames(buyer);
  const statusNames = getNames(status);

  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }

  const query = `query {
  getFilterData(data: 
    {
      userId: ${user.id || ''},
      startDate: "${from || ''}",
      endDate: "${to || ''}",
      status: [ ${statusNames} ],      
      whLocation: [ ${whLocationNames} ],
      comodityType: [${comodityTypeNames}],
      seller: [${sellerNames}],
      brand: [${brandNames}],
      buyer: [${buyerNames}]
    })
    {
    sales {
      id
      title
      price
      isDoller
      postFix
      statusColor
      series
    }
    salesByLocation {
      id
      title
      percent
      value
      quantity
      latLng
    }
    amountOrdesBrand {
      series
      labels
      colors
    }
    orders {
      id
      key
      title
      price
      isDoller
      postFix
      statusColor
      series
      colors
      labels
    }
    ordersByCommodity {
      labels
      Profit
      Loss
      colors
    }
    recentActivity {
      id  
      name
      symbol
      symbolColor
      dateTime
      value
    }
  }
}
  `;

  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());
  return response.data.getFilterData[0];
};

export const savedSearch = async (payload: any) => {
  const { name, groupName, dataFields } = payload.data;
  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }

  let dataFiledsString = dataFields.replace(/\\"/g, '"').replace(/\\\\"/g, '"');

  dataFiledsString = dataFiledsString.replaceAll('"', "'");

  const query = `mutation {
    createFilters(Filters: {
      clientId: "${user.id}",
      ${payload.data.id ? `filterId: ${payload.data.id},`:""}
      dataFields: "${dataFiledsString}",
      groupName: "${groupName}",
      name: "${name}"
    }){
      id
    }
  }`;

  const bodyString = JSON.stringify({
    query,
  });

  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: bodyString,
  }).then((res) => res.json());
  return response.data.createFilters;
};

export const SearchesDelete = async (payload: any) => {
  const { name, groupName } = payload;
  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }

  // let dataFiledsString = `"${dataFields.replace(/"([^"]+)":/g, '$1:')}"`.replace(/\\"/g, '"').replace(/\\\\"/g, '"')
  // dataFiledsString = dataFiledsString.replaceAll('"', "'");

  const query = `mutation {
    deleteFilters(Filters: {
      clientId: "${user.id}",
      groupName: "${groupName}",
      name: "${name}"
    }){
      id
    }
  }`;

  const bodyString = JSON.stringify({
    query,
  });

  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: bodyString,
  }).then((res) => res.json());
  return response.data.deleteFilters;
};
